import { CreditCard, FileCheck2, LockKeyhole, ReceiptText } from "lucide-react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Container, SiteFooter, SiteHeader } from "./SiteChrome";

const destinations = { parent: "/dashboard/payments", staff: "/staff/payments", admin: "/admin/payments", superadmin: "/admin/payments" };

export function PaymentsPage() {
  const { isAuthenticated, user, ready } = useAuth();
  if (ready && isAuthenticated && destinations[user?.role]) return <Navigate to={destinations[user.role]} replace />;
  return <>
    <SiteHeader />
    <main className="public-payments">
      <Container>
        <div className="public-payments__eyebrow"><LockKeyhole size={16} /> Secure payment center</div>
        <div className="public-payments__layout">
          <section>
            <h1>Payments with a clear next step.</h1>
            <p>Formula Soccer uses Stripe Checkout for one-time membership payments. Sign in to review your family’s payment trail, continue an unfinished checkout, or open a receipt.</p>
            <div className="public-payments__actions"><Link className="button button--primary" to="/login">Sign in to payments</Link><Link className="button button--secondary" to="/memberships">View memberships</Link></div>
            {isAuthenticated && user?.role === "coach" && <p className="public-payments__note">Coach accounts do not have access to family payment data. Contact an administrator if you need operational support.</p>}
          </section>
          <aside aria-label="What you can do in the payment center">
            <div><ReceiptText /><span><strong>Follow every transaction</strong>See confirmation, receipt, refund, and enrollment status together.</span></div>
            <div><FileCheck2 /><span><strong>Keep family records handy</strong>Amounts, dates, players, plans, and references stay easy to find.</span></div>
            <div><CreditCard /><span><strong>Resume securely</strong>Continue eligible checkouts without creating duplicate payment records.</span></div>
          </aside>
        </div>
        <p className="public-payments__support">Need help with a charge? <a href="mailto:support@formulasoccer.com">Contact support</a> and include your FSC reference.</p>
      </Container>
    </main>
    <SiteFooter />
  </>;
}
